module.exports = __webpack_public_path__ + "img/image11.63e824f9.png";